import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import DocumentMeta from 'react-document-meta';
import Offers from './offers';
import { getOffers, isLoaded } from '../redux/modules/cellphone';
import * as date from '../utils/date-fns';
import DetailTextSection from '../DetailTextSection';
import { getDetailText } from '../redux/modules/detailText';

const Bundle = __CLIENT__ ? require('../common/bundle').default : null;
const Article = __CLIENT__
  ? require('bundle-loader?lazy!./subscription.article.js')
  : require('./subscription.article.js').default;

const OFFER_TYPE = 'cellphone/subscription';

/** Read and decode ':filter' from router props */
function getFilterFromProps(props) {
  const m = props && props.match;
  return decodeURIComponent((m && m.params && m.params.filter) || '');
}

class Subscription extends Component {
  static async fetchData({ getState, dispatch, params, match }) {
    const filter =
      (params && params.filter) ||
      (match && match.params && match.params.filter) ||
      '';

    if (!isLoaded({ getState })) {
      await dispatch(getOffers());
    }
    if (filter) {
      return dispatch(getDetailText(OFFER_TYPE, filter));
    }
    return null;
  }

  render() {
    const { match, location, feed, detailDoc } = this.props;
    const filter = getFilterFromProps(this.props);

    // Fallbacks if DB fields are missing
    const fallbackTitle = `${match.params && match.params.filter ? match.params.filter + ' ' : ''}Mobilabonnement, spar penge på billig mobiltelefoni (${date.format(
      new Date(),
      'MMMM \'YY'
    )})`;

    const metaTitle = (detailDoc && detailDoc.titleTag) || fallbackTitle;
    const metaDescription = detailDoc && detailDoc.metaDescription ? detailDoc.metaDescription : undefined;

    console.log({ detailDoc, metaDescription, metaTitle });
    const canonical = filter ? `/mobilabonnement/${encodeURIComponent(filter)}` : '/mobilabonnement';

    return (
      <DocumentMeta
        title={metaTitle}
        description={metaDescription}
        canonical={canonical}
        extend
      >
        <Offers
          {...this.props}
          sort={{ weight: -1, 'price.monthly': 1 }}
          filters={{ prepaid: false }}
          category="cellphone/subscription"
        />

        <hr />

        <DetailTextSection
          offerType={OFFER_TYPE}
          filter={filter}
          location={location}
          feed={feed}
          initialDetailDoc={detailDoc}
          fallback={
            __CLIENT__ ? (
              <Bundle load={Article}>{Comp => (Comp ? <Comp /> : null)}</Bundle>
            ) : (
              <Article />
            )
          }
        />
      </DocumentMeta>
    );
  }
}

const mapStateToProps = state => ({
  // detailText reducer already stores the *doc* (with text, titleTag, metaDescription)
  detailDoc: (state && state.detailText && state.detailText.payload) || null
});

export default withRouter(connect(mapStateToProps)(Subscription));
